module.exports = __webpack_public_path__ + "static/media/nexone-partners.a8f416d8.jpg";